import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { PrimaryData } from 'app-models';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ImmigrationWizardService } from '../services/immigration-wizard.service';
import { Subscription } from 'rxjs';
import { CdkStepper } from '@angular/cdk/stepper';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as RolesRouteMap from 'src/app/data/constants/roles';

@Component({
  selector: 'app-soc-code',
  templateUrl: './soc-code.component.html',
  styleUrls: ['./soc-code.component.scss'],
  providers: [DynamicDialogConfig]
})
export class SocCodeComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  inputData;
  companyId;
  wizardInput;
  isDataLoaded = false;
  isManageLca:boolean= false;
  previousUrl: string = null;
  currentUrl: string = null;
  addLcaUrl: string;

  
  constructor(public dynamicDialogConfig: DynamicDialogConfig, private immigrationWizardService: ImmigrationWizardService,private router: Router) { 
    this.addLcaUrl = `/${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/immigration-wizard/upload/soc-code/lca/add-new`;
  }

  ngOnInit(): void {
  this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
  ).subscribe((event: NavigationEnd) => {
     this.previousUrl = this.currentUrl;
     if(this.previousUrl === this.addLcaUrl){
      this.isManageLca= false;
      sessionStorage.getItem("lcaId");
     }
     this.currentUrl = event.url;
  });
    this.subscription = this.immigrationWizardService.getWizardTaskDetails$().subscribe((res: any) => {
      if(res){
        console.log(res);
        this.inputData = {
          "superTaskId": res.superTaskId,
          "subTaskId": res.id,
          "caseType": res.subTaskTypeCode,
          "caseId": res.petitionId, // 1519
          "petitionId": res.petitionId,
          "foreignCompanyId": null,
          "visatype": res.taskTypeDetails.visaType,
          "visaName": res.taskTypeDetails.visaName,
          "petitionType": res.taskTypeDetails.petitionType,
          "immSpecialistId": res.immSpecialistId,
          "attorneyId": res.attorneyId,
          "sponsorId": res.sponsorId,
          "familyId": res.familyId,
          "immigrationCategory": null,
          "immigrationCategoryName": null,
          "immigrationClassification": null,
          "immigrationClassificationName": null,
          "superTaskTypeCode": res.superTaskTypeCode,
          "getTaskType": res.taskTypeDetails.visaType,
          "jsonInput": null,
          "beneficiaryId": res.beneficiaryId,
          "relationshipCode": null,
          "taskTypeId": res.taskTypeId,
          "taskTypeSaveJsonId": null,
          // "stepId": 8524,
          "companyId": res.companyId,
          "petitionerId": res.taskStepDetails[0].petitionerId,
          "layoutCode": "FILL_FORM",
          "taskId": res.taskStepDetails[0].taskId,
          "isCustomStep": false,
          "individualStepId": null,
          'stateProvinceCode': res.stateProvinceCode,
          "countryCode": res.countryCode
          // "version": "wizard"
        } as any;
        this.wizardInput = {
          title: 'SOC Code',
          data: {
            taskId: res?.superTaskId,
            individual: res?.beneficiaryDetails?.firstName+" "+res?.beneficiaryDetails?.lastName,
            petitionType: res?.taskTypeDetails?.petitionType,
            status: res?.taskStatus?.name
          }
        }
        this.isDataLoaded = true; 
        this.companyId = res.companyId;
      }
    });
    console.log('this.inputData app-await-lottery-selection', this.inputData);
  }

  onDeleteLCA(event){
    this.isManageLca= event;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
